import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Section.scss';

export function Section({ children, className, id }) {
	return (
		<section
			id={id}
			className={classnames('page-section', className)}
		>
			{children}
		</section>
	);
}

Section.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	id: PropTypes.string,
};

export default Section;
